export default class CreateTimesheetPinnedBottomRowData {
  execute(source) {
    const resultArray = [];
    source.calculated.forEach((row) => {
      row.values.name = row.name;
      row.values.immutable = true;
      resultArray.push(row.values);
    });
    return resultArray;
  }
}
